export enum SpinButtonState {
    PROCESS = "PROCESS",
    FAILURE = "FAILURE",
    SPIN_NOW = "CANCEL"
}
